<template>
  <div class="bill-comp">
    <div class="module-hd">结算</div>
    <ul class="bill">
      <li>
        <div class="clear">
          <div class="label">服务费用：</div>
          <div class="value">
            <span class="tax price">(含税：¥{{costInfo.WorkLogAmount | formatPrice}})</span>
            ¥{{costInfo.WorkLogAmount_NoTax | formatPrice}}
          </div>
        </div>
      </li>
      <li>
        <div class="clear">
          <div class="label">其他费用：</div>
          <div class="value">
            <span class="tax price">(含税：¥{{costInfo.OtherTaxAmount | formatPrice}})</span>
            ¥{{costInfo.OtherAmount | formatPrice}}
          </div>
        </div>
        <div class="clear remark">
          <div class="label">备注：</div>
          <div class="value">{{costInfo.OtherAmountRemark}}</div>
        </div>
        <div class="clear">
          <div class="label">票证：</div>
          <ul class="pic-list">
            <li v-for="(item,index) in costInfo.OtherAmountFileList" :key="'other'+index">
              <img class="pic" v-if="item.FileType==2" :src="item.FileUrl" preview="1" :preview-text="item.FileName">
              <img class="pic" v-if="item.FileType==1" :src="item.IconUrl" alt />
            </li>
          </ul>
        </div>
      </li>
      <!-- <li v-if="costInfo.Subsidy==3 || costInfo.Subsidy==4">
        <div class="clear">
          <div class="label">补助费用：</div>
          <div class="value">
            <span class="tax price">(含税：¥{{costInfo.SubsidyAmount | formatPrice}})</span>
            ¥{{costInfo.SubsidyAmount_NoTax | formatPrice}}
          </div>
        </div>
      </li> -->
      <li v-if="costInfo.Subsidy==2">
        <div class="clear">
          <div class="label">住宿费用：</div>
          <div class="value">
            <span class="tax price">(含税：¥{{costInfo.HousingTaxAmount | formatPrice}})</span>
            ¥{{costInfo.HousingAmount | formatPrice}}
          </div>
        </div>
        <div class="clear remark">
          <div class="label">备注：</div>
          <div class="value">{{costInfo.HousingPriceRemark}}</div>
        </div>
        <div class="clear">
          <div class="label">票证：</div>
          <ul class="pic-list">
            <li v-for="(item,index) in costInfo.HousingAmountFileList" :key="'house'+index">
              <img class="pic" v-if="item.FileType==2" :src="item.FileUrl" preview="1" :preview-text="item.FileName">
              <img class="pic" v-if="item.FileType==1" :src="item.IconUrl" alt />
            </li>
          </ul>
        </div>
      </li>
      <li v-if="costInfo.Subsidy==2">
        <div class="clear">
          <div class="label">交通费用：</div>
          <div class="value">
            <span class="tax price">(含税：¥{{costInfo.PDTaxAmount | formatPrice}})</span>
            ¥{{costInfo.PDTrafficAmount | formatPrice}}
          </div>
        </div>
        <div class="clear remark">
          <div class="label">备注：</div>
          <div class="value">{{costInfo.TrafficPriceRemark}}</div>
        </div>
        <div class="clear">
          <div class="label">票证：</div>
          <ul class="pic-list">
            <li v-for="(item,index) in costInfo.TrafficAmountFileList" :key="'traffic'+index">
              <img class="pic" v-if="item.FileType==2" :src="item.FileUrl" preview="1" :preview-text="item.FileName">
              <img class="pic" v-if="item.FileType==1" :src="item.IconUrl" alt />
            </li>
          </ul>
        </div>
      </li>
      <!-- <li v-if="costInfo.Subsidy==2">
        <div class="clear">
          <div class="label">餐饮费用：</div>
          <div class="value">
            <span class="tax price">(含税：¥{{costInfo.FoodTaxAmount | formatPrice}})</span>
            ¥{{costInfo.FoodAmount | formatPrice}}
          </div>
        </div>
        <div class="clear remark">
          <div class="label">备注：</div>
          <div class="value">{{costInfo.FoodAmountRemark}}</div>
        </div>
        <div class="clear">
          <div class="label">票证：</div>
          <ul class="pic-list">
            <li v-for="(item,index) in costInfo.FoodAmountFileList" :key="'food'+index">
              <img class="pic" v-if="item.FileType==2" :src="item.FileUrl" preview="1" :preview-text="item.FileName">
              <img class="pic" v-if="item.FileType==1" :src="item.IconUrl" alt />
            </li>
          </ul>
        </div>
      </li> -->
      <li v-if="costInfo.Subsidy==2">
        <div class="clear">
          <div class="label">加班费用：</div>
          <div class="value">
            <span class="tax price">(含税：¥{{costInfo.OvertimeAmount | formatPrice}})</span>
            ¥{{costInfo.OvertimeAmount_NoTax | formatPrice}}
          </div>
        </div>
        <div class="clear remark">
          <div class="label">备注：</div>
          <div class="value">{{costInfo.OvertimeAmountRemark }}</div>
        </div>
        <div class="clear">
          <div class="label">票证：</div>
          <ul class="pic-list">
            <li v-for="(item,index) in costInfo.OvertimeAmountFileList" :key="'food'+index">
              <img class="pic" v-if="item.FileType==2" :src="item.FileUrl" preview="1" :preview-text="item.FileName">
              <img class="pic" v-if="item.FileType==1" :src="item.IconUrl" alt />
            </li>
          </ul>
        </div>
      </li>
      <li>
        <div class="clear">
          <div class="label">增补/扣除：</div>
          <div class="value">
            {{costInfo.SupplementDeduct}}
          </div>
        </div>
      </li>
      <!-- <li>
        <div class="clear">
          <div class="label">减免费用：</div>
          <div class="value">¥{{costInfo.DeductAmount | formatPrice}}</div>
        </div>
      </li> -->
      <!-- <li v-if="costInfo.Subsidy==2">
        <div class="clear">
          <div class="label">票证：</div>
          <div class="value">
            <div class="icon-doc" v-for="item in costInfo.TicketFileList " :key="item.Id">
              <a v-if="item.FileType==2" href="javascript:void(0)" class="link" >
                <img class="pic" :src="item.FileUrl" preview="1" :preview-text="item.FileName" alt />
              </a>
              <a v-if="item.FileType==1" :href="item.FileUrl" class="link" >
                <img class="pic" :src="item.IconUrl" alt />
              </a>
            </div>
          </div>
        </div>
      </li> -->
    </ul>
    <div class="cost-info">
      <div class="item">
        <span class="label">已付押金：</span>
        <span class="value price">¥{{costInfo.PayedDeposit | formatPrice}}</span>
      </div>
      <div class="item" v-if="costInfo.DifferStatus==2">
        <span class="label">需额外支付：</span>
        <span class="value price">¥{{costInfo.TobePayAmount | formatPrice}}</span>
      </div>
      <div class="item" v-if="costInfo.DifferStatus==1">
        <span class="label">待退款：</span>
        <span class="value price">¥{{costInfo.TobePayAmount | formatPrice}}</span>
      </div>
    </div>
    <div class="total">
      总费用:
      <span class="price">¥{{costInfo.TotalAmount | formatPrice}}</span>
    </div>
  </div>
</template>
<script>
import { GetJobSettleDetail } from "@/scripts/api.js";
export default {
  data() {
    return {
      jobNo: "",
      tableData: [],
      costInfo: {},
      jobId: ""
    };
  },
  watch: {
      costInfo(){
          this.$nextTick(()=>{
              this.$previewRefresh(); //图片必须预览刷新才可以点击放大 
          })
      },
  },
  mounted() {
    this.jobNo = this.$route.query.jobNo;
    this.jobId = this.$route.query.jobId;
    this.init();
  },
  methods: {
    init() {
      GetJobSettleDetail({ platform: "pcweb", JobNo: this.jobNo }).then(r => {
        if (r.Result == 1) {
          this.costInfo = r.Data;
        }else{
          this.$toast(r.Message);
        }
      });
    },
    formatDay(value) {
      var str = "";
      switch (value) {
        case 1:
          str = "工作日";
          break;
        case 2:
          str = "周末";
          break;
        case 3:
          str = "节假日";
          break;

        default:
          str = "未定义";
          break;
      }
      return str;
    }
  }
};
</script>
<style lang="scss">
.bill-comp {
  width: 840px;
  padding-top: 50px;
  padding-bottom: 50px;
  .price {
    font-family: "DIN-Regular", Arial, Helvetica, sans-serif;
  }
  .module-hd {
    font-size: 24px;
    color: #333;
    line-height: 1.2;
    font-weight: bold;
  }
  .bill {
    margin-top: 20px;
    li {
      margin-bottom: 15px;
    }
    .label{
      float: left;
      font-size: 14px;
      line-height: 30px;
    }
    .value {
      float: right;
      max-width: 770px;
      font-size: 16px;
      word-break: break-all;
      color: #333;
      max-width: 600px;
      text-align: right;
      font-weight: 600;
      font-family: "DIN-Regular", Arial, Helvetica, sans-serif;
    }
    .tax {
      margin-right: 20px;
      font-size: 14px;
      font-weight: normal;
    }
    .price {
      color: #ff3838;
    }
    // .icon-doc{
    //     display: inline-block;
    //     width: 124px;
    //     height: 124px;
    //     vertical-align: middle;
    //     margin-right: 40px;
    //     position: relative;
    //     background-color: #f8f8f8;
    // }
    // .pic {
    //   position: absolute;
    //   left: 50%;
    //   top: 50%;
    //   transform:translate(-50%,-50%);
    //   max-width: 100%;
    //   max-height: 100%;
    // }
  }
  .pic-list{
    overflow: hidden;
    float: right;
    >li{
      float: left;
      width: 100px;
      height: 100px;
      background-color: #f8f8f8;
      margin-left: 10px;
      margin-bottom: 10px;
      overflow: hidden;
      position: relative;
    }
    .pic{
      position: absolute;
      left: 50%;
      top: 50%;
      transform:translate(-50%,-50%);
      max-width: 100%;
      max-height: 100%;
    }
  }
  .remark > .label,
  .remark > .value {
    color: #999;
    font-size: 14px;
    font-weight: normal;
    font-family: inherit;
  }
  .cost-info {
    padding: 10px 20px;
    background-color: #f9f9f9;
    .item {
      overflow: hidden;
      color: #333;
    }
    .label {
      float: left;
      font-size: 14px;
      line-height: 30px;
      font-weight: 600;
      font-weight: 600;
    }
    .value {
      float: right;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
    }
    .price {
      color: #ff3838;
      font-weight: 600;
    }
  }
  .total {
    text-align: right;
    margin-top: 10px;
    font-size: 16px;
    color: #333;
    .price {
      font-size: 24px;
      color: #ff3838;
      font-weight: bold;
    }
  }
}
</style>